import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasPermissionsDirective } from '../directives/permission.directive';
import { NzSwitchModule } from 'ng-zorro-antd/switch';

@NgModule({
  declarations: [HasPermissionsDirective],
  exports: [HasPermissionsDirective],
  imports: [CommonModule, NzSwitchModule],
})
export class PermissionModule {}
